import { render, staticRenderFns } from "./CardColumnsSectionModule.vue?vue&type=template&id=30c1b7b2&"
import script from "./CardColumnsSectionModule.vue?vue&type=script&lang=js&"
export * from "./CardColumnsSectionModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports